import { injectIntl, compose } from '../dependencies';
import Charts from '../components/Charts';

export default compose(injectIntl)(Charts);
